import script from "./GameKeyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameKeyboard.vue?vue&type=script&setup=true&lang=js"

import "./GameKeyboard.vue?vue&type=style&index=0&id=b9543cfe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9543cfe"]])

export default __exports__